import * as ng from 'angular';
import { AutoResize } from './auto-resize.directive';


export const AutoResizeModule: string =
    ng.module('auto-resize', [
    ])
        .directive('autoResize', AutoResize)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/auto-resize/auto-resize.module.ts